import React from 'react';
import styles from './RegistrMainInfo.module.scss';
import ButtonClose from '../../../../../../../universal_components/ButtonClose/ButtonClose';
import { isMobile } from 'react-device-detect';

const RegistrMainInfo = ({
  short_name,
  contacts,
  onChange,
  isShow,
  description,
  documents,
  improvement_objects,
  accreditation_direction,
  link,
}) => {
  const windowWidth = window.innerWidth;
  const formatLink = (url) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return 'https://' + url;
    }
    return url;
  };

  return (
    <div className={`${styles.mainInfo} `} onClick={onChange}>
      {!short_name ? (
        <div className={styles.empty}>
          <p>Нет соответствующих организаций</p>
        </div>
      ) : (
        <>
          <p className={styles.organization}>
            <span>{short_name}</span>
            <br />
            {link && (
              <a href={formatLink(link)} className={styles.link} target="_blank" rel="noreferrer">
                {link.replace(/^(https?:\/\/)?(www\.)?/, '').split('/')[0]}
              </a>
            )}
          </p>

          {window.innerWidth > 768 && (
            <p className={styles.direction}>
              {accreditation_direction.length > 0
                ? accreditation_direction.map((item) => (
                    <React.Fragment key={item.id}>
                      <span>{item.title}</span>
                      <br />
                    </React.Fragment>
                  ))
                : 'Не указано'}
            </p>
          )}

          {window.innerWidth < 768 && accreditation_direction.length > 0 && (
            <p className={styles.direction}>
              {accreditation_direction.map((item) => (
                <React.Fragment key={item.id}>
                  <span>{item.title}</span>
                  <br />
                </React.Fragment>
              ))}
            </p>
          )}

          <div className={styles.contact}>
            {contacts &&
              contacts.map((item) => (
                <p key={item.id} className={styles.name}>
                  {item.text}
                </p>
              ))}
          </div>

          {isMobile &&
            windowWidth < 769 &&
            (description || documents.length > 0 || improvement_objects.length > 0 || link) && (
              <ButtonClose open={isShow} onChange={onChange} />
            )}
        </>
      )}
    </div>
  );
};

export default RegistrMainInfo;
